import { render } from "./scan-completed-button.vue?vue&type=template&id=15c1e997&scoped=true"
import script from "./scan-completed-button.vue?vue&type=script&lang=js"
export * from "./scan-completed-button.vue?vue&type=script&lang=js"

import "./scan-completed-button.vue?vue&type=style&index=0&id=15c1e997&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/hkust-gz-vitals/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c1e997"]])

export default __exports__